import { datadogRum } from '@datadog/browser-rum';

export const ALARM_SECONDS = 10000;
export const addDDError = (error: unknown, context?: object | undefined) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    if (typeof error === 'string') {
      datadogRum.addError(new Error(error), context);
      return;
    }
    datadogRum.addError(error, context);
    console.error(error);
  } catch (e) {
    console.error(e);
  }
};

export const addDDAction = (name: string, context?: object | undefined) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    datadogRum.addAction(name, context);
  } catch (e) {
    console.error(e);
  }
};

export const initDD = () => {
  if (datadogRum.getInitConfiguration()) return;
  if (
    !process.env.NEXT_PUBLIC_DATADOGROOM_APPLICATION_ID ||
    !process.env.NEXT_PUBLIC_DATADOGROOM_CLIENT_TOKEN
  ) {
    console.error('missing environment config');
    return;
  }
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOGROOM_APPLICATION_ID,
    clientToken: process.env.NEXT_PUBLIC_DATADOGROOM_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: process.env.NEXT_PUBLIC_DATADOGROOM_SERVICE,
    sessionSampleRate: Number(
      process.env.NEXT_PUBLIC_DATADOGROOM_SAMPLE_RATE || 100
    ),
    sessionReplaySampleRate: 100, // if not included, the default is 100
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    excludedActivityUrls: [
      /^(\/(?!\/)|https?:\/\/([a-zA-Z0-9-]+\.)?wwechampions\.com(\/|$))/,
    ],
    env: process.env.NEXT_PUBLIC_ENVIRONMENT,
    enableExperimentalFeatures: ['clickmap'],
    version: process.env.NEXT_PUBLIC_VERSION,
  });

  if (process.env.NEXT_PUBLIC_ENVIRONMENT !== 'prod') {
    datadogRum.startSessionReplayRecording();
  }
};

export const startSessionReplayRecording = () => {
  datadogRum.startSessionReplayRecording();
};

export const addDDUser = ({
  userId,
  userName,
  email,
}: {
  userId: string;
  userName: string;
  email: string;
}) => {
  datadogRum.setUser({
    id: userId,
    name: userName,
    email,
  });
};

export const throwError = (err: unknown, context?: object | undefined) => {
  addDDError(err, context);
  throw err;
};
